import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Button,
  Modal,
} from 'react-bootstrap';

import PaymentForm from './PaymentForm';
import './Payment.css';

const PaymentDialog = observer(
class PaymentDialog extends Component {
  render() {
    let {
      show = false,
      hideFooter = true,
      creditCardOwnerInfo = null,
      addingPayment = false,
    } = this.props;

    return (
      <Modal show={show} onHide={this.onCancel} autoFocus>
        <Modal.Header closeButton>
          <Modal.Title>Payment method</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PaymentForm
            addingPayment={addingPayment}
            creditCardOwnerInfo={creditCardOwnerInfo}
            onSave={this.onSave}
            onCancel={this.onCancel} />
        </Modal.Body>
        <Modal.Footer
          className="PaymentDlg-footer"
          style={{display: hideFooter ? "none" : ""}}>
          <div className="PaymentDlg-footer-left">
            <Button onClick={this.onDelete} bsStyle="danger">Delete</Button>
          </div>
          <div className="PaymentDlg-footer-right">
            <Button onClick={this.onCancel} disabled={addingPayment}>Cancel</Button>
            <Button onClick={this.onSave} bsStyle="primary" disabled={addingPayment}>Save</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  onSave = (token) => {
    let { onSave } = this.props;
    if (onSave) {
      onSave(token);
    }
  }

  onCancel = () => {
    let { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  }

  onDelete = (e) => {
    e.preventDefault();

    let {
      onDelete
    } = this.props;
    if (onDelete) {
      onDelete();
    }

    return false;
  }
});

export default PaymentDialog;


// WEBPACK FOOTER //
// ./src/components/Payment/PaymentDialog.js